import { useEffect, useState } from "react";
import "./App.css";





export default function Games() {
    

  const [tgUserId, setTgUserId] = useState(0);

useEffect(() => {
  const tg = window.Telegram.WebApp;
  if(tg){
    const user = tg.initDataUnsafe?.user;
    if(user){
      setTgUserId(user.id)
    }

  }
},[])


  return (
    <div className="section">
      <div
        style={{
          padding: 20,
          textAlign: "left",
          width: "100%",
        }}
      >
        <div className="mainHeading">
          <i
            className="fa-solid fa-gamepad"
            style={{
              fontSize: 16,
              marginTop:-3
            }}
          ></i>
          &nbsp;&nbsp;Games
        </div>
        <div
          style={{
            marginTop: 20,
          }}
        >
          <div
            style={{
              padding: 20,
            }}
          >
            <strong
              style={{
                fontSize: 30,
              }}
            >
              Play games and Boost your earnings upto 10x times.
            </strong>
            <br />
            <div
              style={{
                fontSize: 14,
              }}
            >
              We offer a wide range of games that you can play, and upon winning
              you can boost your earnings upto 10x times.
            </div>
            <br />
            <div
              className="row"
              style={{
                width: "100%",
              }}
            >
              <div onClick={() => {
                if(global.isLocalUser()){
                  global.changeSection('WHEELOUTER');
                }else{
                  global.changeSection('WHEEL');
                }

              }}
                className="col-6"
                style={{
                  padding: 10,
                }}
              >
                <div
                  className="glowBox"
                  style={{
                    overflow: "hidden",
                    position: "relative",
                  }}
                >
                  <img
                    src={require("./assets/wheel.jpeg")}
                    style={{
                      width: "100%",
                    }}
                  ></img>
                  <div
                    className="glitch-wrapper"
                    style={{
                      width: "100%",
                      height: 40,
                    }}
                  >
                    <div  data-glitch="PLAY NOW" style={{
                      fontSize:11,
                      fontWeight:'bold'
                    }}>
                      PLAY NOW
                    </div>
                  </div>
                </div>
              </div>
            
{(tgUserId == 61022307301) ? <>

  <div
                className="col-6"
                style={{
                  padding: 10,
                }}

               
              >
                <div
                  className="glowBox"
                  style={{
                    overflow: "hidden",
                    position: "relative",
                  }}

                  onClick={() => {
                    window.Telegram.WebApp.openLink("https://emoryanadventure.emorya.com/", { try_instant_view: false });
                  }}
                >

                  <img
                    src={require("./assets/emoryan-adventure.png")}
                    style={{
                      width: "100%",
                    }}
                  ></img>
                  
                 
                </div>
              </div>

</>:

<>

<div
                className="col-6"
                style={{
                  padding: 10,
                }}

                onClick={() => {
                  global.changeSection('EMORYANADVENTURE');
                }}
              >
                <div
                  className="glowBox"
                  style={{
                    overflow: "hidden",
                    position: "relative",
                  }}
                >
                  <img
                    src={require("./assets/emoryan-adventure.png")}
                    style={{
                      width: "100%",
                    }}
                  ></img>
                 
                </div>
              </div>

</>}

              

              <div
                className="col-6"
                style={{
                  padding: 10,
                }}
              >
                <div
                  className="glowBox"
                  style={{
                    overflow: "hidden",
                    position: "relative",
                    display:'none'
                  }}
                >
                  <img
                    src={require("./assets/twist.jpeg")}
                    style={{
                      width: "100%",
                    }}
                  ></img>
                  <div
                    className="glitch-wrapper"
                    style={{
                      width: "100%",
                      height: 40,
                    }}
                  >
                    <div  data-glitch="COMING SOON" style={{
                      fontSize:11,
                      fontWeight:'bold'
                    }}>
                    COMING SOON
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-6"
                style={{
                  padding: 10,
                }}
              >
                <div
                  className="glowBox"
                  style={{
                    overflow: "hidden",
                    position: "relative",
                     display:'none'
                  }}
                >
                  <img
                    src={require("./assets/jigsaw.png")}
                    style={{
                      width: "100%",
                    }}
                  ></img>
                  <div
                    className="glitch-wrapper"
                    style={{
                      width: "100%",
                      height: 40,
                    }}
                  >
                    <div data-glitch="COMING SOON" style={{
                      fontSize:11,
                      fontWeight:'bold'
                    }}>
                    COMING SOON
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <br />
            <br />
          </div>
        </div>
      </div>
    </div>
  );
}
